import * as SmartySDK from 'smartystreets-javascript-sdk'
import { configClient } from '@egw/config'

interface Config {
  smartystreets: {
    apiKey: string
  }
}

/**
 * Address autocomplete
 */
export const getAutoCompleteClient = () => {
  const config = configClient.getConfig() as Config
  const smartySharedCredentials = new SmartySDK.core.SharedCredentials(config.smartystreets.apiKey)
  const autoCompleteClientBuilder = new SmartySDK.core.ClientBuilder(smartySharedCredentials).withLicenses([
    'us-autocomplete-pro-cloud',
  ])
  return autoCompleteClientBuilder.buildUsAutocompleteProClient()
}

/**
 * Address verification
 */
export const getStreetApiClient = () => {
  const config = configClient.getConfig() as Config
  const smartySharedCredentials = new SmartySDK.core.SharedCredentials(config.smartystreets.apiKey)
  const streetClientBuilder = new SmartySDK.core.ClientBuilder(smartySharedCredentials).withLicenses(['us-core-cloud'])
  return streetClientBuilder.buildUsStreetApiClient()
}
